/*Этот главный файл сборки*/
import { joint } from './public/joint';
import { } from './public/pre';
import { act } from './act';
import { } from './admin/fun/shHd';

/***********************************************
 Загружаем JS файлы обработки щаблонов (tmpl). 
 На каждый шаблон свой JS файл
************************************************/
import { } from './public/template/main';
//import { art } from './public/template/art';
//import { tov } from './public/template/tov';
import { } from './public/template/cat';
import { } from './public/template/art';
import { } from './public/template/adm';
//import { Jedit } from './admin/Jedit';

//console.log('JED.tmpl = '+JED.tmpl);
if (!JED.tmpl) JED.tmpl = 'deflt';//deflt.js по умолчанию

/*============================================
 Подписываемся на клик по кнопкам вызова меню
 Показываем/скрываем меню при клике
==============================================*/
const menuBox = document.querySelector('nav.navMenu');
const mobMenu = document.querySelectorAll('.mobMenu');//

window.addEventListener("load", function () {
	//console.log('window.addEventListener("load" ');
	//console.log('JED.tmpl = ' + JED.tmpl);
	mobMenu.forEach(el => {
		el.onclick = () => { 
			document.body.style.width = '100%';
			document.body.style.position = 'fixed';
			//document.body.style.height = '100%';
			//document.body.style.overflowY = 'hidden';
			//document.documentElement.style.height = '100%';
			//document.documentElement.style.overflow = 'hidden';
			menuBox.classList.add("show");	
		}
	});
	document.querySelector('nav button.modal-close').onclick = () =>{
		document.body.style.width = '';
		document.body.style.position = '';
		//document.body.style.height = '';
		//document.body.style.overflowY = '';
		//document.documentElement.style.height = '';
		//document.documentElement.style.overflow = '';
		menuBox.classList.remove("show");
	}

	document.querySelectorAll('.unit').forEach(unit => {
		const obj = unit.dataset.js; // Получаем имя объекта из data-атрибута
		if (window.unit[obj] && typeof window.unit[obj].init === 'function') {
    	    window.unit[obj].init(); //инициализируем
	    } else {
    	    console.warn(`Объект "${obj}" не найден или у него нет метода init`);
	    }
	});
}, true);

//console.log('bundle_edit.js JED.usrPermit = ',JED.usrPermit);
if (JED.usrPermit >= 200) {
	//document.body.insertAdjacentHTML('afterbegin', '<div class="admin"><div class="csMode">&#128393;</div></div>');
	JED.adminPanel = document.querySelector('.adminPanel');
	JED.adminPanel.addEventListener('click', function (e) {
		//console.log('csMode.addEventListener(click, function () {}: ');
		let a = e.target.getAttribute('f');
		//debugger;
		//return;
		if (typeof ed === "undefined") ed = {};
		//console.log("Запускается функция: ", a, e.target);
		JED[a](ed);
	});
}


